import { Component, OnInit } from "@angular/core";
import { CONSTANTS_QUICK_ACTIONS } from "../../../constants/quick-actions.constants";
import { BsModalRef } from "mis-design-system/modal";
import { HomeDataService } from "../../../services/home-data.service";
import { ConfigurationService } from "../../../services/configuration.service";
import { NsWISConfigurations } from "../../../models/configurations.model";

@Component({
  selector: "app-create-booking",
  templateUrl: "./create-booking.component.html",
  styleUrls: ["./create-booking.component.scss"]
})
export class CreateBookingComponent implements OnInit {
  constructor(public modalRef: BsModalRef, private homeData: HomeDataService, public configSvc: ConfigurationService) {}

  quickActions = [];
  config: NsWISConfigurations.IConfigurations;

  ngOnInit(): void {
    this.homeData.configSubject.subscribe(res => {
      const bookingConfigs = res?.BUSettings?.features.find(x => x.id === "booking");
      const configMap = { ...bookingConfigs, ...this.config.flattenedSettings };
      this.quickActions = CONSTANTS_QUICK_ACTIONS.filter(act => act.reqConfigs.every(key => configMap[key]));
    });
  }

  onClickItem(item) {
    this.homeData.publishAction(item.id);
    this.modalRef.hide();
  }
}
